/* Sentry */
import { BrowserTracing } from '@sentry/tracing';

/* Project */
import environments from 'config/environments';

const sentryOptions = {
  dsn: environments.SENTRY_DSN,
  integrations: [new BrowserTracing()],
  tracesSampleRate: environments.TRACES_SAMPLE_RATE,
  /* Without this, QA events are labelled as production. */
  environment: environments.SENTRY_ENV ?? 'production',

  /* Only report errors raised by our own bundle. In-app browsers (Instagram,
     Facebook, LinkedIn) inject scripts that fail on their own and made up 93% of
     the project's event volume. */
  allowUrls: [window.location.origin],

  denyUrls: [
    /^iabjs:\/\//, // in-app WebView bridge (Android)
    /\/beacon\.min\.js/, // Cloudflare beacon
    /extensions\//,
    /^chrome(-extension)?:\/\//,
    /^moz-extension:\/\//,
    /^safari-(extension|web-extension):\/\//,
  ],

  ignoreErrors: [
    /* Native bridges of in-app WebViews */
    'Java object is gone',
    'Java exception was raised during method invocation',
    'window.webkit.messageHandlers',
    '_AutofillCallbackHandler',
    /* Autofill scripts the Android WebView injects into the page (execute_auto_fill,
       needInjectCss). They are not part of our bundle, but their frames are
       <anonymous> and, without a filename, allowUrls cannot drop them. */
    'xbrowser is not defined',
    'swbrowser is not defined',
    'isAllowAutoFillOnDomain',
    /* Script the Instagram/Facebook in-app browser (iOS) injects inline into the
       document. Its frames carry our own URL as filename, so allowUrls lets them
       through and only the message can drop them. */
    'window._META',
    /* Browser noise we cannot act on */
    'ResizeObserver loop',
    'NS_ERROR_FAILURE',
  ],
};

export default sentryOptions;
